import {
  createSanitizationProfile,
  htmlTagGroups,
} from 'utils/sanitizeHtml/utils/createSanitizationProfile/createSanitizationProfile';

/**
 * Represents the WhatsApp channel specific sanitization profile.
 *
 * Note that this should be kept in sync with
 * https://faq.whatsapp.com/general/chats/how-to-format-your-messages/?lang=en
 */
export const whatsAppSanitizationProfile = createSanitizationProfile({
  allowedTags: [
    ...htmlTagGroups.italic,
    ...htmlTagGroups.bold,
    ...htmlTagGroups.strikethrough,
    ...htmlTagGroups.inlineCode,
  ],
});
